__turbopack_context__.v({
  "genButton": "PKkBFW_genButton",
  "header": "PKkBFW_header",
  "label": "PKkBFW_label",
  "root": "PKkBFW_root",
});
